import React, { ReactNode } from 'react'
import ErrorPage from '../../pages/error'
import type { NextRouter } from 'next/router'

interface IErrorBoundaryProps {
  router?: NextRouter
  children: ReactNode
}

interface IErrorBoundaryState {
  error: any
  info: any
}

class ErrorBoundary extends React.Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  public constructor(props: IErrorBoundaryProps) {
    super(props)

    this.state = {
      error: null,
      info: null,
    }
  }

  public componentDidCatch(error: Error | undefined, info: any): void {
    this.setState({
      error,
      info,
    })
  }

  handleRouteChange = (): void => {
    if (this.state.error) {
      this.setState({
        error: null,
      })
    }
  }

  componentDidMount(): void {
    // if the location of history changes, we reset the
    // error state to keep the back button working
    if (this.props.router) {
      //find a next.js solution
      this.props.router.events.on('routeChangeStart', this.handleRouteChange)
    }
  }

  componentWillUnmount(): void {
    this.props.router?.events.off('routeChangeStart', this.handleRouteChange)
  }

  public render(): JSX.Element | ReactNode {
    const { error } = this.state

    if (error) {
      return <ErrorPage errorMessage={error.message} />
    }

    return this.props.children
  }
}

export default ErrorBoundary
